import { getPlatformTerritory } from '../utils/config';
import { useMemo } from 'react';
import { CURRENCY_SWISS_FRANC, CURRENCY_EURO } from '../components/molecules/form/InputCurrency';

const territoryToCurrency = territory => {
  if (territory === 'ch') {
    return CURRENCY_SWISS_FRANC;
  }
  return CURRENCY_EURO;
};

const currencySymbolMap = {
  [CURRENCY_SWISS_FRANC]: 'CHF',
  [CURRENCY_EURO]: '€'
};

/**
 * @return {{name: string, currencySymbol: string, currency: string}}
 */
export const useTerritory = () => {
  const territoryName = getPlatformTerritory();
  return useMemo(() => {
    const currency = territoryToCurrency(territoryName);

    return {
      name: territoryName,
      currency,
      currencySymbol: currencySymbolMap[currency]
    };
  }, [territoryName]);
};
